/**
 * Indicateur à côté de l'HORA d'une SKILLCARD (migrations 0315, 0345) : la
 * perte RÉELLE depuis le dernier exercice (« −12 HORA »), ambre si l'HORA
 * baisse, rouge s'il baisse vite. Rien tant qu'aucun HORA n'est perdu — en
 * particulier le jour même d'un exercice (l'érosion commence le lendemain).
 * Court par construction : il tient dans la colonne HORA, sur une ligne.
 */

import { TrendingDown } from 'lucide-react';
import { cn } from '@jeraisonne/ui';
import { formatHora, type HoraStatus } from '@jeraisonne/db/cards';

export function HoraTrendBadge({
  status,
  className,
  compact = false,
}: {
  status: HoraStatus;
  className?: string;
  /** Pastille la plus courte (icône + « −12 »), pour les lignes de liste. */
  compact?: boolean;
}) {
  const { trend, lost } = status;
  if (status.stored <= 0 || trend === 'stable' || lost < 1) return null;
  const strong = trend === 'forte_baisse';
  const description = `HORA ${strong ? 'en forte baisse' : 'en baisse'} : −${formatHora(lost)} depuis ton dernier exercice`;
  return (
    <span
      data-trend={trend}
      title={description}
      aria-label={description}
      className={cn(
        'inline-flex max-w-full items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-semibold',
        strong
          ? 'ocean:bg-red-500/20 ocean:text-red-300 bg-red-100 text-red-700'
          : 'ocean:bg-amber-500/20 ocean:text-amber-200 bg-amber-100 text-amber-700',
        className,
      )}
    >
      <TrendingDown className="h-3.5 w-3.5 shrink-0" aria-hidden />
      <span className="truncate">{compact ? `−${lost}` : `−${formatHora(lost)}`}</span>
    </span>
  );
}
